<template>
  <vx-card>
    <vs-table
      :sst="true"
      @search="handleSearch"
      @change-page="handleChangePage"
      @sort="handleSort"
      v-model="selected"
      pagination
      max-items="10"
      search
      :data="accounts"
    >
      <template slot="thead">
        <vs-th sort-key="email">Company</vs-th>
        <vs-th sort-key="username">Actual Company Name</vs-th>
        <vs-th sort-key="website">Switchboard</vs-th>
        <vs-th sort-key="id">Site Switchboard</vs-th>
        <vs-th sort-key="email">Address 1</vs-th>
        <vs-th sort-key="username">Address 2</vs-th>
        <vs-th sort-key="website">Address 3</vs-th>
        <vs-th sort-key="id">Town</vs-th>
        <vs-th sort-key="email">County</vs-th>
        <vs-th sort-key="username">Postcode</vs-th>
        <vs-th sort-key="website">Country</vs-th>
        <vs-th sort-key="id">Website</vs-th>
        <vs-th sort-key="id">Site Address 1</vs-th>
        <vs-th sort-key="id">Site Address 2</vs-th>
        <vs-th sort-key="id">Site Address 3</vs-th>
        <vs-th sort-key="id">Site Town</vs-th>
        <vs-th sort-key="id">Site Country</vs-th>
        <vs-th sort-key="id">Site Postcode</vs-th>
        <vs-th sort-key="id">Registered Address 1</vs-th>
        <vs-th sort-key="id">Registered Address 2</vs-th>
        <vs-th sort-key="id">Registered Address 3</vs-th>
        <vs-th sort-key="id">Registered Town</vs-th>
        <vs-th sort-key="id">Registered County</vs-th>
        <vs-th sort-key="id">Registered Postcode</vs-th>
        <vs-th sort-key="id">Registered Country</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].ml_accounts">
            {{ data[indextr].ml_accounts }}
          </vs-td>

          <vs-td :data="data[indextr].actual_account_name">
            {{ data[indextr].actual_account_name }}
          </vs-td>

          <vs-td :data="data[indextr].ml_switchboards">
            {{ data[indextr].ml_switchboards }}
          </vs-td>

          <vs-td :data="data[indextr].site_switchboard">
            {{ data[indextr].site_switchboard }}
          </vs-td>
          <vs-td :data="data[indextr].address_1">
            {{ data[indextr].address_1 }}
          </vs-td>

          <vs-td :data="data[indextr].address_2">
            {{ data[indextr].address_2 }}
          </vs-td>

          <vs-td :data="data[indextr].address_3">
            {{ data[indextr].address_3 }}
          </vs-td>

          <vs-td :data="data[indextr].town">
            {{ data[indextr].town }}
          </vs-td>
          <vs-td :data="data[indextr].county">
            {{ data[indextr].county }}
          </vs-td>
          <vs-td :data="data[indextr].postcode">
            {{ data[indextr].postcode }}
          </vs-td>

          <vs-td :data="data[indextr].country">
            {{ data[indextr].country }}
          </vs-td>

          <vs-td :data="data[indextr].ml_websites">
            {{ data[indextr].ml_websites }}
          </vs-td>

          <vs-td :data="data[indextr].site_address_1">
            {{ data[indextr].site_address_1 }}
          </vs-td>
          <vs-td :data="data[indextr].site_address_2">
            {{ data[indextr].site_address_2 }}
          </vs-td>
          <vs-td :data="data[indextr].site_address_3">
            {{ data[indextr].site_address_3 }}
          </vs-td>

          <vs-td :data="data[indextr].site_town">
            {{ data[indextr].site_town }}
          </vs-td>

          <vs-td :data="data[indextr].site_country">
            {{ data[indextr].site_country }}
          </vs-td>

           <vs-td :data="data[indextr].site_postcode">
            {{ data[indextr].site_postcode }}
          </vs-td>

           <vs-td :data="data[indextr].registered_address_1">
            {{ data[indextr].registered_address_1 }}
          </vs-td>

           <vs-td :data="data[indextr].registered_address_2">
            {{ data[indextr].registered_address_2 }}
          </vs-td>

            <vs-td :data="data[indextr].registered_address_3">
            {{ data[indextr].registered_address_3 }}
          </vs-td>

            <vs-td :data="data[indextr].registered_town">
            {{ data[indextr].registered_town }}
          </vs-td>
            <vs-td :data="data[indextr].registered_county">
            {{ data[indextr].registered_county }}
          </vs-td>  
            <vs-td :data="data[indextr].registered_postcode">
            {{ data[indextr].registered_postcode }}
          </vs-td>  
            <vs-td :data="data[indextr].registered_country">
            {{ data[indextr].registered_country }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
export default {
  data: () => ({
                            abilities : null,

    selected: [],
    log: [],
    accounts: []
  }),
  methods: {
    handleSearch(searching) {
      console.log(`The user searched for: ${searching}`);
    },
    handleChangePage(page) {
      console.log(`The user changed the page to: ${page}`);
    },
    handleSort(key, active) {
      console.log(`the user ordered: ${key} ${active}`);
    }
  },
  mounted() {
    this.$http
      .get(this.$base_url + "/api/accounts")
      .then(response => {
        this.accounts = response.data.data;
        console.log(this.accounts);
      })
      .catch(error => {
        console.log(error);
      });
  },
  created(){
        var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });  
  }
};
</script>
